<template>
  <div id="page-commercial-product-extra-info-form">
    <vs-row>
      <vs-col :class="readonly ? 'readonly-form' : ''">
        <card-page
            :card-title="cardTitle"
            :switch-model="model.IsEnabled"
        >
          <vue-element-loading :active="busy"></vue-element-loading>
          <vue-form-generator
              ref="form"
              :model="model"
              :options="formOptions"
              :schema="schema"
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import FormModelMixin from "@/components/mixins/FormModelMixin";
import CardPage from '../../components/Views/CardPage';

const selectOptions = {
  showLabels: false,
  key: "id",
  trackBy: "id",
  label: "name",
};

export default {
  name: "CommercialProductExtraInfoForm",
  components: {
    CardPage,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    cardTitle: {
      type: String,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  mixins: [FormModelMixin],
  data() {
    return {
      model: {
        InsurerDescription: null,
        CoverageDescription: null,
        GuaranteeDescription: null,
        InsuredAmountsDescription: null,
        ExcessDescription: null,
        RetroactivityDescription: null,
        ProductImage: null,
      },
      schema: {
        groups: [
          {
            legend: 'Extra Info',
            styleClasses: "w-full",
            fields: [
              {
                disabled: this.readonly,
                type: "input",
                inputType: "textArea",
                styleClasses: "w-1/3",
                label: "Insurer Description",
                model: "InsurerDescription",
              },
              {
                disabled: this.readonly,
                type: "input",
                inputType: "textArea",
                styleClasses: "w-1/3",
                label: "Coverage Description",
                model: "CoverageDescription",
              },
              {
                disabled: this.readonly,
                type: "input",
                inputType: "textArea",
                styleClasses: "w-1/3",
                label: "Guarantee Description",
                model: "GuaranteeDescription",
              },
              {
                disabled: this.readonly,
                type: "input",
                inputType: "textArea",
                styleClasses: "w-1/3",
                label: "Insured Amounts Description",
                model: "InsuredAmountsDescription",
              },
              {
                disabled: this.readonly,
                type: "input",
                inputType: "text",
                styleClasses: "w-1/3",
                label: "Excess Description",
                model: "ExcessDescription",
              },
              {
                disabled: this.readonly,
                type: "input",
                inputType: "text",
                styleClasses: "w-1/3",
                label: "Retroactivity Description",
                model: "RetroactivityDescription",
              },
              {
                disabled: this.readonly,
                type: "input",
                inputType: "text",
                styleClasses: "w-1/3",
                label: "Product Image",
                model: "ProductImage",
              },
              {
                type: 'vsCheckbox',
                styleClasses: 'w-1/3',
                label: 'Oris',
                model: 'IsOris',
                disabled: () => this.readonly,
              },
              {
                disabled: this.readonly,
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: "w-1/3",
                label: "Nodes",
                model: "CommercialProductNode_FK",
                values: () => this.commercialProductNodeOptions,
                selectOptions,
              },
              {
                disabled: this.readonly,
                type: "input",
                inputType: "text",
                styleClasses: "w-1/3",
                label: "Tag",
                model: "Tag",
              },
            ]
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      wordings: [],
      formReferences: [
          'form',
      ],
      commercialProductNodeOptions: [],
      options: [
        {
          endpoint: () => this.$api.commercialProducts.nodesList(),
          optionsFieldName: "commercialProductNodeOptions",
          nameFieldName: "name",
          idFieldName: 'CommercialProductNode_FK',
        },
      ],
    };
  },
  async created() {},
  methods: {},
};
</script>

<style scoped>

</style>
